import { useLocalI18n  as useI18n } from '@/composables/useLocalI18n'
<script setup lang="ts">
import { SpeedInsights } from '@vercel/speed-insights/nuxt'

const { initLastSearches } = useSearchInput()
const { locale } = useI18n()
const { isIos } = useDevice()
const { windowSizeChanged } = useBreakpoint()
const config = useRuntimeConfig()
const modalCount = useModalCount()
const { notifications, removeNotifications } = useNotifications()
const route = useRoute()
const { setRoute } = useHeaderNavigation()
const { user, fetchUserPropertiesByLocation } = useUser()
const { setLock } = useLockBody()
const { organization } = useGlobalStructuredData()

// handle header theme
setRoute(route.name?.toString() || '')

onBeforeMount(() => {
  window.addEventListener('resize', windowSizeChanged)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', windowSizeChanged)
})

onMounted(async () => {
  initLastSearches()
  if (config.public.appDomain === 'production')
    await fetchUserPropertiesByLocation()
})

useHead({
  title: config.public.siteName,
  titleTemplate: `%s - ${config.public.siteName}`,
  htmlAttrs: {
    lang: locale.value,
  },
  meta: [
    { charset: 'utf-8' },
    { content: 'IE=edge,chrome=1', 'http-equiv': 'X-UA-Compatible' },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1'.concat(
        // prevent automatic zoom-in on iOS devices when focusing an input with a font-size < 16px
        // https://stackoverflow.com/a/57527009
        isIos ? ', maximum-scale=1' : '',
      ),
    },
    { name: 'description', content: 'Meta description' },
    {
      name: 'theme-color',
      content: '#202020',
    },
  ],
  script: [
    {
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [organization.value],
      }),
      type: 'application/ld+json',
    },
  ],
})

// Handle modal lock scroll
watch(modalCount, (value) => {
  if (value > 0) {
    setLock(true)
  } else {
    setLock(false)
  }
})
</script>

<template>
  <div>
    <NuxtLoadingIndicator color="#EBDECA" />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <SpeedInsights v-if="config.public.enableVercel" />

    <ClientOnly>
      <LazyThePopinCglPartner v-if="user.partnershipAgency" />
      <LazyThePopinMeetingScheduler />
      <template v-if="notifications.length">
        <LazyTheToastNotification
          v-for="toast in notifications"
          :key="toast.id"
          :message="toast.message"
          :duration="toast.duration"
          :link="toast.link"
          :show-close-button="toast.showCloseButton"
          :title="toast.title"
          :toast-class="toast.toastClass"
          :type="toast.type"
          @close="removeNotifications(toast.id)"
        />
      </template>
    </ClientOnly>
  </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
